/**
 * Money and ratios of "Last changes" (CU-869fn0gcp): the server speaks per day, as strings (Decimal); the screen
 * shows Total (× rental length) or Per day — the one place the unit is applied (TL C3: nothing else is recomputed;
 * percentages and points are unit-free). Pure and alias-free.
 */
const isNum = v => typeof v === 'number' && Number.isFinite(v)

/** A server amount (string per day) as a number, or null. */
export function toNumber(v) {
	if (v === null || v === undefined || v === '') return null
	const n = Number(v)
	return Number.isFinite(n) ? n : null
}

/** The amount in the page's unit: per day as is, total = per day × rental length (both sides, the same unit). */
export function inUnit(v, unit, lor) {
	const n = toNumber(v)
	if (n === null) return null
	return unit === 'day' ? n : n * (lor || 1)
}

/** `288.97 €`, or `—`. */
export function money(n) {
	return isNum(n) ? `${n.toFixed(2)} €` : '—'
}

/** `−16.60 €` · `+9.02 €` · `0.00 €` */
export function signedMoney(n) {
	if (!isNum(n)) return '—'
	const r = Math.round(n * 100) / 100
	return r === 0 ? '0.00 €' : `${r > 0 ? '+' : '−'}${Math.abs(r).toFixed(2)} €`
}

/** The money difference of a pair in the page's unit, or null. */
export function diffInUnit(before, after, unit, lor) {
	const a = inUnit(before, unit, lor), b = inUnit(after, unit, lor)
	return a === null || b === null ? null : b - a
}

/**
 * The € change of a server side (`{start, end, diff}` of the cards and ACRISS rows) in the page's unit: the server's
 * `diff` — the mean of each rate's change in euros — when it comes, `end − start` otherwise. Null without a figure.
 */
export function sideDiffInUnit(side, unit, lor) {
	if (side?.diff !== undefined && side?.diff !== null) return inUnit(side.diff, unit, lor)
	return diffInUnit(side?.start, side?.end, unit, lor)
}

/** `before → after` in the unit, each `—` when missing. */
export function pairText(before, after, unit, lor) {
	return `${money(inUnit(before, unit, lor))} → ${money(inUnit(after, unit, lor))}`
}
